import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Sticky } from 'react-sticky'
import Link from 'gatsby-link'

// Components
import Icon from '../icon/icon'
import SimpleButton from '../button/simple'

const entering = keyframes`
from {
  opacity: 0;  
  transform: translateY(-100%);
}
  to {
    transform: translateY(0%);
    opacity: 1;    
  }
`

const StyledHeader = styled.header`
  padding-top: 1rem;
  padding-bottom: 1rem;
  z-index: 11;
  &.header {
    background: transparent;
    position: absolute;
    &.sticked {
      background: ${props => (props.transparent ? 'trasparent' : 'white')};
      box-shadow: rgba(67, 70, 89, 1) 0px 0px 10px 0px;
      animation: ${entering} 0.5s ease-in-out;
    }
  }
`

const StyledHamburguer = styled.i`
  cursor: pointer;
  font-size: 2rem;
  color: ${props => (props.changeWhite ? 'white' : '#434659')};
  &.open {
    color: white;
  }
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`

const StyledIcon = styled(Icon)`
  &.normal {
    width: 7rem;
    height: 3rem;
  }
  &.open {
    width: 2.8rem;
    height: 3rem;
  }
`

const Header = ({
  toggleMenu,
  isOpen,
  toggleContact,
  contactIsOpen,
  welcomeIsOpen
}) => (
  <Sticky topOffset={350}>
    {({ style, isSticky }) => {
      style.width = '100%'

      const hamburguer = contactIsOpen ? (
        <StyledHamburguer
          changeWhite={welcomeIsOpen}
          className={`${
            contactIsOpen !== true ? 'icon-menu' : 'icon-close open'
          }`}
          onClick={() => {
            toggleContact(!contactIsOpen)
          }}
        />
      ) : (
        <StyledHamburguer
          changeWhite={welcomeIsOpen}
          className={`${isOpen !== true ? 'icon-menu' : 'icon-close open'}`}
          onClick={() => {
            toggleMenu(!isOpen)
          }}
        />
      )

      return (
        <StyledHeader
          className={
            isSticky === true
              ? 'header container-fluid sticked'
              : 'header  container-fluid'
          }
          style={style}
          transparent={isOpen || contactIsOpen}
        >
          <div className="row d-flex align-items-center">
            <div
              className={`col-lg col ${isOpen !== true && 'mr-auto'} pl-lg-5`}
            >
              <Link to="/">
                <Icon
                  className="d-none d-md-block"
                  name={'logo-ppm'}
                  style={{ width: '7rem', height: '3rem' }}
                  fill={
                    isOpen === true ||
                    contactIsOpen === true ||
                    welcomeIsOpen === true
                      ? 'white'
                      : '#434659'
                  }
                />
                <StyledIcon
                  className={`d-block d-md-none ${
                    isOpen !== true ? 'normal' : 'open'
                  }`}
                  name={
                    isOpen !== true ||
                    contactIsOpen === true ||
                    welcomeIsOpen === true
                      ? 'logo-ppm'
                      : 'logo-ppm-alone'
                  }
                  fill={
                    isOpen === true ||
                    contactIsOpen === true ||
                    welcomeIsOpen === true
                      ? 'white'
                      : '#434659'
                  }
                />
              </Link>
            </div>
            <div
              className={`col-lg-auto justify-content-center col-auto px-2 ${
                isOpen !== true ? 'd-none' : 'd-flex'
              } d-lg-flex`}
            >
              {!contactIsOpen ? (
                <SimpleButton
                  isOpen={isOpen || welcomeIsOpen}
                  title="Conversemos"
                  onClick={() => toggleContact(!contactIsOpen)}
                />
              ) : (
                ''
              )}
            </div>
            <div className="col-lg-auto col-auto align-self-stretch d-flex align-items-center">
              {hamburguer}
            </div>
          </div>
        </StyledHeader>
      )
    }}
  </Sticky>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header/header.js